import _pickBy from 'lodash/pickBy';

const userFilters = filters => {
  const {
    name,
    username,
    email,
    supplier_id,
    identification,
    page,
    per_page,
    hasBiometricReader = 'todos',
    hasAutentication = 'todos',
    hasAuthenticationEnabled = 'todos',
    serial,
    blocked
  } = filters;

  const sanitizedFilters = {
    fullName: name,
    username,
    email,
    identification,
    supplierId: supplier_id,
    blocked,
    serial,
    page,
    perPage: per_page
  };

  if (hasBiometricReader !== 'todos') {
    sanitizedFilters.hasBiometricReader = hasBiometricReader;
  }

  if (hasAutentication !== 'todos') {
    sanitizedFilters.hasAuthentication = hasAutentication;
  }

  if (hasAuthenticationEnabled !== 'todos') {
    sanitizedFilters.hasAuthenticationEnabled = hasAuthenticationEnabled;
  }

  return _pickBy(sanitizedFilters, filter => !!filter || filter === false);
};

export default userFilters;
